import $ from 'jquery';
import select2 from 'select2';
import 'select2/dist/css/select2.min.css';

const select = (element) => {
  const placeholder = element.getAttribute('placeholder') ? element.getAttribute('placeholder') : false;
  const search = element.getAttribute('data-search') ? element.getAttribute('data-search') : false;
  const main = $(element).select2({
    width: '100%',
    placeholder,
    search,
    dropdownCssClass: 'select-dropdown',
  });
  main.on('select2:open', () => {
    element.classList.add('is-focus');
  });
  main.on('select2:close', () => {
    element.classList.remove('is-focus');
  });
  main.on('select2:select', () => {
    element.classList.add('is-filled');
  });
  $(this).on('select2:unselect', () => {
    element.classList.remove('is-filled');
  });
};

const mountSelect = () => {
  const elements = Array.from(document.querySelectorAll('[data-select="input"]'));

  elements.forEach(select);
};

export default mountSelect;
export { select };
